import type { ReactNode } from "react";
import mdfMark from "@/assets/mdf-mark.png";

/** Centered spinner or message used by the sign-in screens, in the mdf.lu style. */
export function FullPageMessage({
  spinner = false,
  title,
  children,
}: {
  spinner?: boolean;
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <div className="relative mx-auto mb-6 grid size-16 place-items-center">
          {spinner && (
            <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-border border-t-primary" />
          )}
          <img src={mdfMark} alt="" className="size-9 object-contain brightness-0 dark:invert" />
        </div>
        <h1 className="m-0 text-xl font-semibold text-foreground">{title}</h1>
        {children && <div className="mt-3 text-sm leading-relaxed text-muted-foreground">{children}</div>}
      </div>
    </div>
  );
}
